import { axios } from 'lib'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  orderId: string
  nfeId: number
}

const createOrderNFE = async (params: Params): Promise<any> => {
  const result = await axios.get(`media/nfe`, { params })
  return result
}

export function useDownloadOrderNFE() {
  return useMutation(createOrderNFE, {
    onSuccess: (data) => {
      window.open(data, '_blank')
    },
    onError: (error: any) => {
      if (error?.response?.status === 404)
        toast.error('NF impresso não encontrado!')
      else toast.error('Não foi possível obter o pdf!')
    }
  })
}
